<template>
    <div
        class="select"
        :style="fieldStyle"
    >
        <select
            :id="id"
            :name="name"
            :class="inputClass"
            :style="controlStyle"
            v-model="myValue"
            v-bind="$attrs"
            @change="onInput"
        >
            <option
                v-for="option in options"
                :value="option.value"
                v-text="option.label"
            />
        </select>
        <p
            class="help is-info"
            v-if="info"
            v-html="info"
            style="line-height: 1;"
        />
        <p
            class="help is-danger"
            v-if="validator && validator.$dirty && validator.$invalid"
        >
            {{ errorMessage }}
        </p>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        value: {
            type: [Number, String],
            default: '',
        },
        // loading: {
        //     type: Boolean,
        //     default: false,
        // },
        id: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: null,
        },
        options: {
            type: Array,
            default() { return []; },
        },
        inputClass: {
            type: Array,
            default() { return []; },
        },
        validator: {
            type: Object,
            default: null,
        },
        info: {
            type: String,
            default: null,
        },
        // errorCond: {
        //     type: Boolean,
        //     default: true,
        // },
        errorMessage: {
            type: String,
            default: '',
        },
        fieldStyle: {
            type: String,
            default: null,
        },
        controlStyle: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            myValue: this.value,
        }
    },
    watch: {
        value(cur, prev) {
            this.myValue = cur;
        },
    },
    methods: {
        onInput($event) {
            this.validator && this.validator.$touch();
            this.myValue = $event.target.value;
            this.$emit('input', this.myValue);
        },
    }
}
</script>

<style lang="scss">
.select select {
    font-size: 1rem !important;
}
</style>
